export function coerceObjectProperty(value: any, fallbackValue: any = null) {
   return typeof value === 'object' ? value : fallbackValue;
}
